/**
 * @description 腾讯视频PC客户端 Js bridge统一适配
 * @author aprilcai
 */

import { parseBridgeResult } from './util';
import { isTenvideoMac } from './ua';

let bridge: {
  $invoke: (api: string, param: any, resolve: (...args: any[]) => void) => void;
};

if (isTenvideoMac) {
  bridge = {
    $invoke: (api: string, param: any, resolve: (...args: any[]) => void) => {
      window.TenvideoJSBridge.callHandler(api, JSON.stringify(param), (res: any) => {
        resolve(parseBridgeResult(res));
      });
    },
  };
} else {
  bridge = {
    $invoke: (api: string, param: any, resolve: (...args: any[]) => void) => {
      window.external.callHandler(api, param, (res: any) => {
        resolve(parseBridgeResult(res));
      });
    },
  };
}

export default async function invokeAsync(api: string, param: any): Promise<BridgeResult> {
  return new Promise((resolve) => {
    bridge.$invoke(api, param, resolve);
  });
}
